import React from 'react';

const SVG = ({
  style = {},
  fill = '#000',
  viewBox = '0 0 16 16',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <g fill={fill}>
      <circle cx="7.5" cy="14.5" r="1.5" />
      <circle cx="7.5" cy="8.5" r="1.5" />
      <circle cx="7.5" cy="2.5" r="1.5" />
    </g>
  </svg>
);
export default SVG;
